import { api } from '@tech_hexeko/hexeko-api-classes'
import Vue from 'vue'
let _ = require('lodash')

const sessionName = 'bearerToken'

// initial state
const state = () => ({
    user: null,
    token: null,
    config: {
        type: 'client',
        client: {
            loginUrl: null
        },
        verify: true,
        store_id: null
    },
    loginErrors: {}
})

// getters
const getters = {
    isLogged: (state) => {
        return state.token
    },
    getConfig: (state) => {
        return state.config
    },
    userHasRole: (state) => (role) => {
        return state.user && state.user.roles.includes(role)
    },
    userHasPermission: (state) => (permission) => {
        return state.user && state.user.permissions.includes(permission)
    },
    userHasAnyPermission: (state) => (permissions) => {
        return state.user && Array.isArray(permissions) && state.user.permissions && _.intersection(permissions, state.user.permissions).length > 0
    },
    userHasAllPermission: (state) => (permissions) => {
        return state.user && Array.isArray(permissions) && state.user.permissions && _.intersection(permissions, state.user.permissions).length === permissions.length
    },
    passVerification: (state) => {
        if (state.user === null) return null
        return !!(!state.config.verify || (state.user.terms_confirmed && state.user.first_name && state.user.last_name && state.user.phone && state.user.locale && state.user.email))
    },
    passUserEnabled: (state) => {
        if (state.user === null) return false
        return !!(!state.config.must_be_enabled || state.user.enabled === true)
    }
}

// actions
const actions = {
    setConfig ({ commit }, config) {
        commit('setConfig', { config })
    },
    shouldLogin ({ getters }, { next, to }) {
        let config = getters.getConfig
        if (config.type === 'client') {
            // redirect to url
            window.location.href = config.client.loginUrl
            return next(false)
        }
        else if (config.type === 'password') {
            // ask token
            return next({
                name: 'login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    },
    postLogin ({ dispatch }) {
        dispatch('changeLoading', true, { root: true })
    },
    setLoginErrors ({ commit, dispatch }, errors) {
        commit('setLoginErrors', { errors })
        dispatch('changeLoading', false, { root: true })
    },
    setToken ({ commit, dispatch }, token) {
        // Set token
        commit('setToken', { token })
        // Set API token
        dispatch('api/setToken', token, { root: true })
        // Set Exporter API token
        dispatch('exporterApi/setToken', token, { root: true })
        // Set Importer API token
        dispatch('importerApi/setToken', token, { root: true })
        // Set Verification API token
        dispatch('verificationApi/setToken', token, { root: true })
        // Set session token
        if (token) {
            Vue.$cookies.set(sessionName, token, '2d')
        }
        else {
            Vue.$cookies.remove(sessionName)
        }
    },
    setUser ({ commit }, user) {
        commit('setUser', { user })
    },
    async fetchUserIfNecessary({ state, dispatch }) {
        if (state.user) {
            await state.user
        }
        else if (state.token) {
            await dispatch('fetchUser')
        }
        else {
            await Promise.resolve(false)
        }
    },
    async fetchUser ({ dispatch }) {
        return await api.me.showProfile().then(user => {
            dispatch('setUser', user)
        }).catch(() => {
            console.log('Cannot fetch profile')
        })
    },
    loginWithSession ({ dispatch }) {
        let token = Vue.$cookies.get(sessionName)
        if (token) {
            dispatch('setToken', token)
        }
    },
    logout ({ dispatch }) {
        dispatch('setToken', null)
        dispatch('setUser', null)
    }
}

// mutations
const mutations = {
    setUser (state, { user }) {
        state.user = user
    },
    setToken (state, { token }) {
        state.token = token
    },
    setConfig (state, { config }) {
        state.config = _.merge(state.config, config)
    },
    setLoginErrors (state, { errors }) {
        state.loginErrors = errors
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
